<template>
    <v-card outlined max-width="950px" min-height="650px" class="mx-auto pa-6 pa-sm-10 mb-12 border-top-left-radius:0; border-top-right-radius:0;">
        <v-row>
            <v-col cols="12" sm="5" md="4">
                <v-card flat class="transparent" max-width="250px" style="border-radius:20px">
                    <v-img :src="require('@/assets/products/summercamp-application.png')"></v-img>
                </v-card>
            </v-col>
            <v-col cols="12" sm="7" md="7">
                <div class="display-1 font-weight-medium green--text">Congratulations!</div>
                <div class="headline font-weight-medium primary--text mt-2 mb-1">{{message.name}}</div>
                <div style="line-height:1.4" v-html="message.thankyou"></div>
                <v-btn depressed large class="accent white--text mt-6" :href="'https://steps-online.web.app/summercamp-application?email='+item.email">Fill your application form</v-btn>
            </v-col>
        </v-row>
        
    </v-card>
</template>

<script>
import Cart from  '@/firebase/cart'

export default {
    data: () => ({
        message: null,
        sessionId: null,
        item: null,
        objSummercampApplication: {
            name: '3 Steps Summercamp Application Fee',
            thankyou: 'Thank you for your interest in the 3 Steps to College Summercamp Program. Your application fee was processed successfully. You will receive an email with further instructions on how to apply to the program. Please stay tuned!'
        }
    }),
    mounted() {
        let url = new URL(window.location.href);
        this.sessionId = url.searchParams.get('session_id');
        this.$gtm.trackView('SuccessSummercampApplication', '/success-summercamp-application');
        this.init();
    },
    methods: {
        init() {
            Cart.getByPayment(this.sessionId)
                .then(response => {
                    if (response.status === true) {
                        this.item = response.query.docs[0].data();
                        if (this.item.id_product == 'summercamp-application') this.message = this.objSummercampApplication;
                    } else {
                        this.$store.dispatch('setSnack', {kind:'error', text:FireErrors.get(response)});
                    }
                });
        }
    }
}
</script>